import "./styles.less";

import { Button, Carousel, Space } from "antd";
import React, { useEffect, useRef } from "react";

import { CarouselArrow } from "../../../LazyImageGallery/CarouselArrow/web";
import { useTheme } from "../../../../../Styles/ThemeHook";
import { monthShortName, weekdayShortName } from "@Utils/dateFormats";


export const DateSelector = ({ onSelect, selected, disabled }) => {
	const { theme } = useTheme();

	return (
		<Carousel
			className="date-selector"
			dots={false}
			arrows={true}
			infinite={false}
			autoplay={false}
			slidesToShow={4}
			slidesToScroll={4}
			initialSlide={0}
			responsive={[
				{
					breakpoint: Number(
						theme.breakPoints.lg.substring(0, theme.breakPoints.lg.length - 2)
					),
					settings: {
						slidesToShow: 6,
						slidesToScroll: 6,
					},
				},
				{
					breakpoint: Number(
						theme.breakPoints.md.substring(0, theme.breakPoints.md.length - 2)
					),
					settings: {
						slidesToShow: 5,
						slidesToScroll: 5,
						initialSlide: 5,
					},
				},
				{
					breakpoint: Number(
						theme.breakPoints.sm.substring(0, theme.breakPoints.sm.length - 2)
					),
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
						initialSlide: 4,
					},
				},
			]}
			nextArrow={<CarouselArrow side={"right"} type={"filled"} position={"outside"} />}
			prevArrow={<CarouselArrow side={"left"} type={"filled"} position={"outside"} />}>
			{[0, 1, 2, 3, 4, 5, 6].map((o, i) => {
				const d = new Date();
				d.setHours(0, 0, 0, 0);
				d.setDate(d.getDate() + o);
				return (
					<DateButton
						disabled={disabled}
						key={"date_button_" + i}
						onClick={() => onSelect(d)}
						date={d}
						selected={selected ? selected.getTime() == d.getTime() : o == 0}
					/>
				);
			})}
		</Carousel>
	);
};

export const DateButton = ({ date, onClick, selected, key, disabled }) => {
	const ref = useRef(null);
	const { theme } = useTheme();

	useEffect(() => {
		if (selected) ref.current.click();
	}, []);

	return (
		<Button
			disabled={disabled}
			onClick={onClick}
			className={"secondary date-button"}
			style={{
				height: "auto",
				width: "100%",
				...(selected
					? { borderWidth: "2px", borderColor: theme.colors.secondaryColor }
					: { margin: "1px 0" }),
			}}
			ref={ref}>
			<Space direction={"vertical"} size={0} style={{ textAlign: "center" }}>
				<span  style={{textTransform:'capitalize'}}>{weekdayShortName(date)}</span>
				<strong style={{ fontSize: "26px" }}>
					{date.getDate()}
				</strong>
				<span style={{textTransform:'capitalize'}}>{ monthShortName(date) }</span>
			</Space>
		</Button>
	);
};
